import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';

export default function filterreducer(state = initialstate.filter, action) {
	switch (action.type) {
		case actions.SET_FILTERS: {
			if (action.filter) {
				let result = {
					...state,
					[action.key]: {
						...state[action.key],
						[action.filter.name]: {
							...action.filter,
							value: action.value
						}
					}
				};

				if (!Utility.hasValue(result[action.key][action.filter.name].value)) {
					delete result[action.key][action.filter.name].value;
				}

				result.isLoaded = true;

				return result;
			} else {
				return {
					...state,
					[action.key]: action.value
				};
			}
		}

		case actions.SET_MULTIPLE_FILTERS: {
			if (action.filters) {
				let newFilters = {};
				_.forEach(action.filters, (item) => {
					newFilters[item.name] = item;
				});

				let result = {
					...state,
					[action.key]: {
						...state[action.key],
						...newFilters
					}
				};

				_.forEach(action.filters, (item) => {
					if (!Utility.hasValue(result[action.key][item.name].value)) {
						delete result[action.key][item.name].value;
					}
				});

				return result;
			} else {
				return {...state};
			}
		}

		case actions.SET_TASKS_MULTIPLE_MENU_FILTER: {
			let filters = {...state};
			if (action.filterKey) {
				filters[action.filterKey] = {...action.filters};
			}
			filters = {...filters, ...action.resetfilters, refresh: true};
			return filters;
		}

		case actions.CLEAR_ALL_FILTERS: {
			if (action.parentName) {
				let filters = {...state};
				filters[action.parentName] = {};
				return filters;
			} else {
				return {...state};
			}
		}

		case actions.CLEAR_FILTERS: {
			if (!action.parentName) {
				if (action.selectedKey) {
					return {...state, [action.key]: {...state[action.key], [action.selectedKey]: {}}};
				} else {
					return {...state, [action.key]: {}};
				}
			} else {
				let result = {...state[action.key]};

				Object.entries(result).forEach((filter) => {
					if (
						!filter[1].appliesTo ||
						(filter[1].appliesTo && filter[1].appliesTo.some((item) => item === action.parentName))
					) {
						delete result[filter[0]];
					}
				});

				return {
					...state,
					[action.key]: result
				};
			}
		}
		case actions.SET_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				value = null;
			}

			let filters;
			if (!action.parentName) {
				filters = {...state.filters};
				if (action.filterKey) {
					if (filters[action.filterKey]) {
						filters[action.filterKey] = {...filters[action.filterKey]};
					} else {
						filters[action.filterKey] = {};
					}

					filters[action.filterKey][action.filterItemName] = value;
				} else {
					filters[action.filterItemName] = value;
				}

				let result = {...state};
				return {
					...result,
					filters
				};
			} else {
				let specific = {};
				if (state[action.parentName]?.filters.specific) {
					specific = {...state[action.parentName].filters.specific};
				}
				specific[action.filterItemName] = value;
				return {
					...state,
					[action.parentName]: {
						filters: {
							...state[action.parentName]?.filters,
							specific
						}
					}
				};
			}
		}
		case actions.SET_LOAD_STATE: {
			return {
				...state,
				isLoaded: action.isLoaded
			};
		}

		default:
			return state;
	}
}
